module.exports = require("@tauri-apps/tauri-inliner");;